import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import AdminLayout from '../components/AdminLayout'
import TanStackQueryLayout from '../integrations/tanstack-query/layout.tsx'
import AuthGuard from '../components/AuthGuard.tsx'
import type { QueryClient } from '@tanstack/react-query'

interface MyRouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <AuthGuard>
      <AdminLayout>
        <>
          <Outlet />
          <TanStackRouterDevtools />
          <TanStackQueryLayout />
        </>
      </AdminLayout>
    </AuthGuard>
  ),
})
